
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DialyseComponent } from './components/dialyse/dialyse.component';
import { InterventionListComponent } from './components/intervention-list/intervention-list.component';
import { InterventionComponent } from './components/intervention/intervention.component';
import { PointageComponent } from './components/pointage/pointage.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { WeeklyListComponent } from './components/weekly-list/weekly-list.component';
import { ZoneComponent } from './components/zone/zone.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './models/enums/navigation-route';
import { LoginGuard } from './tools/login-guard';
import { EndoscopeComponent } from './components/endoscope/endoscope.component';
import { FileComponent } from './components/file/file.component';
import { AppareilsComponent } from './components/appareils/appareils.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.InterventionList },
    { path: ENavigationRoute.WeeklyList, component: WeeklyListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.InterventionList, component: InterventionListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Intervention, component: InterventionComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Pointage, component: PointageComponent, canActivate: [LoginGuard] },
    // { path: ENavigationRoute.Scan, component: ScanComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Zone, component: ZoneComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Generateur, component: DialyseComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Endoscope, component: EndoscopeComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Plan, component: FileComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Appareils, component: AppareilsComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
